
import { map } from 'rxjs/operators';
import { Component } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { Router } from '@angular/router';
import { KeyValue } from '../../shared/key-value';
import { AuthorizationService } from '../../shared/authorization.service';
// import { NguiPopupComponent, NguiMessagePopupComponent } from '@ngui/popup';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'shared-view-summary',
  templateUrl: 'view-summary.component.html',

})
export class ViewSummaryComponent {
  worksessions: any;
  session_name: any; error_message: any;
  // variable for sorting
  currentSortColumn: string = '';
  isSortAscending: boolean = true;
  showExpired: boolean = false;
  changeControlPath: string = KeyValue.workSessionPath;
  session_running: any;
  is_debug = false;
  index: any;
  sub_cur_session: any;
  role='';
  KeyValue: any = {
    delete_title: "Delete Session",
    delete_session_confirm: "Are you sure, you want to delete Session?",
  };
  //   customPopup = document.getElementById('customPopup');
  //  deleteButton = document.getElementById('deleteButton');
  // cancelButton = document.getElementById('cancelButton');
  // closeButton = document.getElementById('closeButton');

  // @ViewChild(NguiPopupComponent) popup: NguiPopupComponent;
  constructor(private router: Router, private _tokenService: AngularTokenService,
    private KeyValueService: KeyValue, public authService: AuthorizationService,
    private http: HttpClient,
  ) {
    if (localStorage.getItem('debug') == 'true') {
      this.is_debug = true;
    }
    this.changeControlPath = this.authService.getChangeControlPath();
  }

  openPopup(work_session, index) {
    const customPopup = document.getElementById('customPopup');
    customPopup.style.display = 'flex';
    let modal = document.getElementById('customPopup');
    if(modal) this.trapFocus(modal);

    function closePopup() {
      customPopup.style.display = 'none';
    }
    // Handle the "OK" button click
    const deleteButton = document.getElementById('deleteButton');
    deleteButton.addEventListener('click', () => {
      this.DeleteWorksession(work_session.id, index);
      closePopup();
    });
    // Handle the "Cancel" and "Close" button clicks
    const cancelButton = document.getElementById('cancelButton');
    const closeButton = document.getElementById('closeButton');
    cancelButton.addEventListener('click', closePopup);
    closeButton.addEventListener('click', closePopup);
  }

  reset(id, reset_flag) {
    if (reset_flag === true) {
      this.authService.get(KeyValue.api_rollforward, { params: { name: id } }).pipe(
        map(res => res)).subscribe(
          data => {
            const quarter_array = { quarter: [], id: '', is_set: reset_flag, sim_exe_status: data.sim_exe_status };
            quarter_array.quarter = data.quater_name;
            quarter_array.id = id;
            quarter_array.is_set = reset_flag;
            this.KeyValueService.quarter_list_update(quarter_array);
          }
        );
    } else {
      this.authService.get(KeyValue.api_reset_quarter, { params: { name: id } }).pipe(
        map(res => res)).subscribe(
          data => {
            const quarter_array = { quarter: [], id: '', is_set: reset_flag, sim_exe_status: data.sim_exe_status };
            quarter_array.quarter = data.quater_name;
            quarter_array.id = id;
            quarter_array.is_set = reset_flag;
            this.KeyValueService.quarter_list_update(quarter_array);
          }
        );
    }
  }

  rollbackDecision(worksession) {
    this.authService.post(KeyValue.api_rollback_decision_executed, { wid: worksession.id }).pipe(
      map(res => res)).subscribe(
        data => {
          console.log(data)
        },
        error => {
          console.log('in... api failure' + error)
        }
      );
  }

  // gets all the record of worksessions
  SessionInformation() {
    this.authService.get(KeyValue.api_sessions_index).pipe(
      map(res => res)).subscribe(
        data => {
          this.worksessions = data.worksessions
        },
        error => {
          console.log('in... signin success' + error)
        }
      );
  }

  //redirects to admin home page
  AdminHomePage() {
    this.router.navigate([KeyValue.adminPath]);
  }

    //redirects to admin control page
    AdminControlPage(selectedSession) {
      console.log('clicked AdminControlPage');
      this.sub_cur_session = this.KeyValueService.current_session$.subscribe(
        data => {
          console.log('AdminControlPage selectedSession: 001', selectedSession);
          setTimeout(()=>{
            this.router.navigate([this.authService.getChangePath(KeyValue.simulationStatusPath)]);        
  
          },500)
          try {
            document.getElementById('sim-dashboard').classList.add('bold');
          } catch (error) {
            console.log('sim-dashboard Element not found:', error);
          }
        });
      this.KeyValueService.setCurrentSession(selectedSession);
      this.authService.setCurrentSession(selectedSession);
      this.KeyValueService.current_session_update(selectedSession);
    }
  
  //redirects to admin control page
  // AdminControlPage(selectedSession) {
  //   this.KeyValueService.setCurrentSession(selectedSession);
  //   this.authService.setCurrentSession(selectedSession);
  //   this.KeyValueService.current_session_update(selectedSession);
  //   this.router.navigate([this.authService.getChangePath(KeyValue.simulationStatusPath)]);
  //   //debugger;
  // }

  Delete(work_session, index) {
    this.getWorkSession(work_session, index);
  }

  ngOnInit() {
    this.SessionInformation();
    this.role = this.authService.getCRole();
  }

  ngOnDestroy() {
    if (this.sub_cur_session !== undefined) {
      this.sub_cur_session.unsubscribe();
    }
  }


  //calls delete api by passing particular worksession id
  DeleteWorksession(id, index) {
    this.http.delete(environment.base_url + KeyValue.api_sessions_destroy + id).pipe(
      map(res => JSON.parse(JSON.stringify(res)))).subscribe(
        data => {
          this.KeyValueService.list_worksessions_update(this.worksessions[index]);
          this.worksessions.splice(index, 1)
          if (data.status == 200) {
            KeyValue.flash_msg_update({ msg: 'Simulation deleted.', type: 'success_messages' })
          }
        },
        error => {
          console.log('in... api failure' + error)
        }
      );
  }

  getWorkSession(work_session, index) {
    this.authService.get(KeyValue.api_get_session_status, { params: { work_session_id: work_session.id } }).pipe(
      map(res => res)).subscribe(
        data => {
          this.session_running = data.worksession_status;
          if (this.session_running !== true) {
            this.openPopup(work_session, index);
          } else {
            this.simulation_running_popup();
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  AddNewSession() {
    const addSimulationPopup = document.getElementById('add-simulation-modal');
    addSimulationPopup.style.display = 'flex';
    let modal = document.getElementById('add-simulation-modal');
    if(modal) this.trapFocus(modal);

    function closePopup() {
      addSimulationPopup.style.display = 'none';
    }
    const cancelAddSimulation = document.getElementById('cancelAddSimulation');
    const closeAddSimulation = document.getElementById('closeAddSimulation');
    cancelAddSimulation.addEventListener('click', closePopup);
    closeAddSimulation.addEventListener('click', closePopup);
  }

  simulation_running_popup() {
    const customPopup1 = document.getElementById('customPopup1');
    customPopup1.style.display = 'flex';
    let modal = document.getElementById('customPopup1');
    if(modal) this.trapFocus(modal);

    function closePopup() {
      customPopup1.style.display = 'none';
    }
    // Handle the "OK" button click
    const deleteButton1 = document.getElementById('deleteButton1');
    deleteButton1.addEventListener('click', () => {
      closePopup();
    });
    // Handle the "Cancel" and "Close" button clicks
    // const cancelButton = document.getElementById('cancelButton');
    const closeButton1 = document.getElementById('closeButton1');
    // cancelButton.addEventListener('click', closePopup);
    closeButton1.addEventListener('click', closePopup);
  }

  // Hide and show expired 
  toggleExpired() {
    this.showExpired = !this.showExpired;
    console.log(this.showExpired);
  }

  FindUser() {
    this.router.navigate([KeyValue.instructorAdminFindUserPath]);
  }

  addNewSimulation() {
    this.router.navigate([this.authService.getChangePath(KeyValue.changeControlPath)]);
  }

  addNewEconomy() {
    this.router.navigate([ this.authService.getChangePath(KeyValue.addEconomyPath) ]) ;
  }

  // Functions for sorting the table

  sortData(column: string) {
    if (this.currentSortColumn === column) {
      this.isSortAscending = !this.isSortAscending;
    } else {
      this.currentSortColumn = column;
      this.isSortAscending = true;
    }

    this.worksessions.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      let comparison = 0;

      if (valueA > valueB) {
        comparison = 1;
      } else if (valueA < valueB) {
        comparison = -1;
      }

      return this.isSortAscending ? comparison : -comparison;
    });
  }

  getSortDirection(column: string) {
    if (this.currentSortColumn === column) {
      return this.isSortAscending ? 'asc' : 'desc';
    }
    return '';
  }

  execute_start_quarter() {
    this.authService.get(KeyValue.api_execute_start_quarter).pipe(
      map(res => res)).subscribe(
        data => {
          console.log(data)
        },
        error => {
          console.log('in... api failure' + error)
        }
      );
  }

  ShowMessage(response: any) {
    console.log(response)
    if (response.status == 201) {
      this.router.navigate([this.changeControlPath]);
    }
    else {
      this.error_message = response.errors.name;
      console.log(this.error_message)
    }
  }

  // on click of create & edit button on Add new simulation popup
  submit(): void {
    this.authService.post(KeyValue.api_sessions_create, { worksession: { name: this.session_name } }).pipe(
      map(res => res)).subscribe(
        data => {
          if (data.session != undefined && data.status === 201) {
            console.log("Simulationssss", data.session)
            this.KeyValueService.setCurrentSession(data.session);
            this.authService.setCurrentSession(data.session);
            this.KeyValueService.all_worksessions_update(data.session);
            this.KeyValueService.current_session_update(data.session);
            const addSession = this;
            setTimeout(function () {
              addSession.execute_start_quarter();
              addSession.ShowMessage(data);
            }, 1000);
          } else {
            this.error_message = 'Simulation name already exists. Please use different simulation name.'; //data.errors.name[0];
          }
        },
        error => {
          console.log('in... api failure' + error)
        }
      );
  }

  private getFocusableElements(modal: HTMLElement): HTMLElement[] {
    return Array.from(
      modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ) as HTMLElement[];
  }

  private trapFocus(modal: HTMLElement): void {
    const focusableElements = this.getFocusableElements(modal);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
  
    // Focus the first element
    firstFocusableElement.focus();
  
    // Add event listener for Tab key
    modal.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Tab') {
        if (event.shiftKey) {
          // Shift + Tab: Move focus backward
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Tab: Move focus forward
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    });
  }

}